import { cultures, CultureSettings } from "../EasyProjectsCommon/i18n";

export let currentCultureSettings: CultureSettings;
export const setCulture = function (cultureName?: string) {
    // for tests only
    if (cultureName) {
        ep.currentCulture = cultureName as keyof typeof cultures;
        ep.resxCulture = cultureName.slice(0, 2).toLowerCase();
    }

    currentCultureSettings = ep.currentCultureSettings = cultures[ep.currentCulture];

    if (!ep.currentCultureSettings) {
        (function () {
            let currentKey = ep.currentCulture.slice(0, 2).toLowerCase();
            ep.currentCulture = "en-US";

            Object.keys(cultures).forEach((key: keyof typeof cultures) => {
                if (key.slice(0, 2).toLowerCase() === currentKey) {
                    ep.currentCulture = key;
                    currentCultureSettings = ep.currentCultureSettings = cultures[key];
                    return;
                }
            });

            currentCultureSettings = ep.currentCultureSettings = cultures[ep.currentCulture];
        })();
    }
};

// for QUnit tests
(window as any).setCulture = setCulture;

// jest initialize new module if test suite has jest.mock(...) .As a result the culture initialization from
// jest-global-setup.js is lost. So restore it in this case.
if (process.env.NODE_ENV === "test") {
    currentCultureSettings = ep.currentCultureSettings;
}
